<app-svg-icon style="cursor: pointer;"  (click)="onPreviewClick(params)" name="printView" ></app-svg-icon>